module.exports = __webpack_public_path__ + "static/img/BCA_logo.0025dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/BCA_logo.png
// module id = Ck6K
// module chunks = 0